module.exports = __webpack_public_path__ + "img/list_hk1_1_tc.a3856478.png";